import {
  IconBrandName,
  IconLucideCoins,
  IconLucideCreditCard,
  IconLucideGlobe,
  IconLucideMonitorSmartphone,
  IconLucideScanSearch,
  IconLucideSparkle,
  IconSearch,
} from '@wegic/icon';
import intl from 'react-intl-universal';
import checkoutPreview from './background.png';
import Badge from './badge.png';
import styles from './index.module.less';

const TRIAL_FEATURES = [
  { key: 'price.checkout.left.trial.feature.1', Icon: IconLucideSparkle },
  { key: 'price.checkout.left.trial.feature.2', Icon: IconLucideCreditCard },
  { key: 'price.checkout.left.trial.feature.4', Icon: IconLucideMonitorSmartphone },
  { key: 'price.checkout.left.trial.feature.5', Icon: IconLucideScanSearch },
  { key: 'price.checkout.left.trial.feature.6', Icon: IconLucideGlobe },
  { key: 'price.checkout.left.trial.feature.7', Icon: IconLucideCoins },
] as const;

export default function CheckoutLeftPanel() {
  return (
    <div className={styles.panel}>
      <img src={checkoutPreview} alt="" className={styles['bg-image']} />

      <div className={styles.body}>
        {/* 顶部 Logo + Badge */}
        <div className={styles.header}>
          <IconBrandName className={styles.logo} />
          <div className={styles['built-badge']}>
            <span>{intl.get('price.checkout.left.built.badge')}</span>
            <IconSearch fontSize={16} />
          </div>
        </div>

        {/* 内容区：卡片 + 底部链接 */}
        <div className={styles.content}>
          {/* 内容卡片 */}
          <div className={styles.card}>
            {/* 左侧：标签 + 标题 */}
            <div className={styles['card-left']}>
              <div className={styles['trial-badge']}>
                <img src={Badge} alt="" style={{ height: 16 }} />
              </div>
              <div className={styles.headline}>
                {intl.get('price.checkout.left.headline')}
              </div>
            </div>

            <div className={styles.divider} />

            {/* 右侧：功能列表 */}
            <div className={styles['card-right']}>
              {TRIAL_FEATURES.map(({ key, Icon }) => (
                <div key={key} className={styles['feature-item']}>
                  <span className={styles['feature-icon']}>
                    <Icon fontSize={16} />
                  </span>
                  <span>{intl.get(key)}</span>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
